import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
export var RevenueRadarLogoIcon = function RevenueRadarLogoIcon(props) {
  var _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 38 38' : _props$viewBox,
      _props$width = props.width,
      width = _props$width === void 0 ? '24px' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '24px' : _props$height;
  var classes = useStyles(props);
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: width,
      height: height,
      viewBox: viewBox
    },
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M18.75,-1.31450406e-13 C29.1043244,-1.31450406e-13 37.5,8.39396497 37.5,18.7517106 C37.5,29.106035 29.1043244,37.5 18.75,37.5 C8.39567558,37.5 -2.13162821e-14,29.106035 -2.13162821e-14,18.7517106 C-2.13162821e-14,8.39396497 8.39567558,-1.31450406e-13 18.75,-1.31450406e-13 Z M18.75,15.4451008 C16.9247788,15.4451008 15.4451008,16.9247788 15.4451008,18.7517106 C15.4451008,20.5752212 16.9247788,22.0548992 18.75,22.0548992 C18.8355305,22.0548992 18.9193504,22.051478 19.0048809,22.0446355 L19.0048809,22.0446355 L24.0323647,27.6999133 C24.3847505,28.0967749 24.8722744,28.3294179 25.4025636,28.3567877 C25.4367758,28.3584983 25.470988,28.3584983 25.5052003,28.3584983 C25.9995666,28.3584983 26.4665633,28.1771736 26.8326339,27.8401834 C27.5664857,27.1662029 27.6605693,26.0457531 27.0926467,25.2520299 L27.0926467,25.2520299 L21.9830536,19.439376 C22.02924,19.2169966 22.0548992,18.9877748 22.0548992,18.7517106 C22.0548992,16.9247788 20.5752212,15.4451008 18.75,15.4451008 Z M27.4279263,11.6834687 C23.9588085,7.1760104 17.7492929,6.01621659 12.9835325,8.98412554 C10.4227488,10.5784144 8.6642414,13.0587994 8.03131557,15.9685476 C7.40181097,18.8475048 7.9697336,21.9026549 9.58454977,24.3436958 C9.91469756,24.8397728 10.4449868,25.1733418 11.0402792,25.2537405 C11.6526777,25.3375604 12.2633656,25.1511039 12.7252304,24.7491105 C13.5138217,24.0614451 13.6729085,22.8777028 13.0930116,21.9950278 C12.1025682,20.4862695 11.7621567,18.6028875 12.1624396,16.827274 C12.564433,15.0345543 13.6643554,13.5121111 15.2569337,12.5404844 C18.2385275,10.7221056 22.0771371,11.5192501 24.1863197,14.3947861 C25.5394125,16.238824 25.8216632,18.3018201 24.9903065,20.269022 L24.9903065,20.269022 L27.9633473,23.5858954 C30.3958352,19.8447906 30.2025363,15.2928565 27.4279263,11.6834687 Z"
    }))
  );
};
var useStyles = makeStyles(function (theme) {
  return {
    cls1: function cls1(props) {
      return {
        fill: props.color ? props.color : theme.palette.product.revenueRadar,
        fillRule: 'evenodd'
      };
    }
  };
});